export default "__VITE_ASSET__BoDmGrBN__"